import ReduxHelper from 'lib/ReduxHelper';
import { BIDS_ACTION_TYPES as AT } from './Bids.actions';

export const defaultState = {
  message: null,
  fetching: false,
  data: null,

  creatingBid: false,
  createdBid: null,
  selectedBid: true,

  cancelingBid: false,
  selectingBid: false,
};

const bidsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case AT.BIDS_FETCH_DATA:
      return Object.assign({}, state, { fetching: true });
    case Attr.BIDS_FETCH_DATA_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        data: action.payload,
        error: null,
      });
    case AT.BIDS_FETCH_DATA_FAIL:
      return Object.assign({}, state, {
        data: null,
        message: ReduxHelper.formatMessage(action),
      });
    case AT.BIDS_CLEAR_DATA:
      return Object.assign({}, state, {
        fetching: false,
        data: null,
        error: null,
      });

    case AT.BID_CANCEL:
      return Object.assign({}, state, { cancelingBid: true });
    case AT.BID_CANCEL_SUCCESS:
      return Object.assign({}, state, { cancelingBid: false });
    case AT.BID_CANCEL_FAIL:
      return Object.assign({}, state, {
        cancelingBid: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.BID_TEMP_SELECT:
      return Object.assign({}, state, {
        selectingBid: true,
        selectedBid: false,
      });
    case AT.BID_TEMP_SELECT_SUCCESS:
      return Object.assign({}, state, {
        selectingBid: false,
        selectedBid: true,
      });
    case AT.BID_TEMP_SELECT_FAIL:
      return Object.assign({}, state, {
        selectedTempBid: false,
        selectingBid: false,
        message: ReduxHelper.formatMessage(action),
      });

    default:
      return state;
  }
};

export default bidsReducer;
